import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

type GenieAPI_convertation_payload = {
    access_token: string
    query: string
    project_key: string
}

export function useTestopsGenieApi() {
    const callApi = useApiCall()

    const conversation = <P, R>(data: GenieAPI_convertation_payload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.TESTOPS_GENIE.CONVERSATION, data, onSuccess, onError)
    }
    const chat = <P, R>(data: GenieAPI_convertation_payload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.TESTOPS_GENIE.CHAT, data, onSuccess, onError)
    }
    const getChatByConversationID = <P, R>(data: GenieAPI_convertation_payload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.TESTOPS_GENIE.GET_CHAT_BY_CONVERSATION_ID, data, onSuccess, onError)
    }
    const getSuggestedQuestions = <P, R>(data: GenieAPI_convertation_payload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.TESTOPS_GENIE.GET_SUGGESTED_QUESTIONS, data, onSuccess, onError)
    }
    const addUser = <P, R>(data: GenieAPI_convertation_payload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.TESTOPS_GENIE.ADD_USER, data, onSuccess, onError)
    }
    const getConversationList = <P, R>(data: GenieAPI_convertation_payload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.TESTOPS_GENIE.GET_CONVERSATION_LIST, data, onSuccess, onError)
    }
    const getChatHistory = <P, R>(data: GenieAPI_convertation_payload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.TESTOPS_GENIE.GET_HISTORY, data, onSuccess, onError)
    }
    const chatSocket = <P, R>(data: GenieAPI_convertation_payload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.TESTOPS_GENIE.CHAT_SOCKET, data, onSuccess, onError)
    }

    return {
        conversation,
        chat,
        getChatByConversationID,
        getSuggestedQuestions,
        addUser,
        getConversationList,
        getChatHistory,
        chatSocket,
    }
}
